import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TableRowsIcon from "@mui/icons-material/TableRows";
import { a11yProps } from "../../../components/TabPanel";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import PropTypes from "prop-types";

/** Existing report tabs sit along the top edge of the transaction panel. */
const TransactionsTabs = ({ value, onChange }) => {
  //tab handle
  const handleTabChange = (event, newValue) => {
    onChange(newValue);
  };

  return (
    <Tabs
      value={value}
      onChange={handleTabChange}
      aria-label="Transaction views"
      sx={({ palette }) => ({
        backgroundColor: "rgba(0, 0, 0, 0)",
        display: { xs: "none", sm: "flex" },
        px: { xs: 2, sm: 2.875 },
        minHeight: 58,
        "& .MuiTabs-flexContainer": { gap: 3.25 },
        "& .MuiTabs-indicator": {
          height: 2,
          borderRadius: "2px",
          backgroundColor: palette.dark.main,
        },
        "&& .MuiTab-root": {
          minHeight: 58,
          padding: "0 1px",
          marginRight: 0,
          fontWeight: 500,
          "&:hover, &.Mui-selected": {
            backgroundColor: "rgba(0, 0, 0, 0)",
            color: palette.dark.main,
          },
          "&.Mui-selected": { fontWeight: 500 },
          "&.Mui-focusVisible": { outline: "2px solid " + palette.brand.main, outlineOffset: -4 },
        },
      })}
      variant="standard"
    >
      <Tab
        disableRipple
        icon={<TableRowsIcon />}
        iconPosition="start"
        label="Transaction Grid"
        {...a11yProps(0)}
      />

      <Tab
        disableRipple
        icon={<MonetizationOnOutlinedIcon />}
        iconPosition="start"
        label="Summary Report"
        {...a11yProps(1)}
      />
    </Tabs>
  );
};
TransactionsTabs.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
};

export default TransactionsTabs;
